import { d as g } from "./-utils.js";
const v = [
  { section: "header", id: "cart-icon-bubble" },
  { section: "mini-cart", id: "mini-cart" },
  { section: "cart-live-region-text", id: "cart-live-region-text" }
];
class y {
  constructor() {
    this.sections = [], this.bxgyRules = [], this.products = {}, this.variants = {}, this.updateQueue = Promise.resolve(), this.isProcessingUpdate = !1;
    try {
      typeof window < "u" && window.giftRules ? this.bxgyRules = window.giftRules.map((e) => ({
        product_x: e.product_x,
        variant_x_id: e.variant_x_id,
        variant_x_available: e.variant_x_available,
        variant_x_inventory: e.variant_x_inventory,
        quantity_x: e.quantity_x,
        product_y: e.product_y,
        variant_y_id: e.variant_y_id,
        variant_y_available: e.variant_y_available,
        variant_y_inventory: e.variant_y_inventory,
        quantity_y: e.quantity_y,
        product_z: e.product_z,
        variant_z_id: e.variant_z_id,
        variant_z_available: e.variant_z_available,
        variant_z_inventory: e.variant_z_inventory
      })) : this.bxgyRules = [];
    } catch (e) {
      console.error("Error initializing BXGY rules:", e), this.bxgyRules = [];
    }
    this.sections = v;
    const a = document.querySelector("lor-mini-cart");
    if (a) {
      const e = a.getAttribute("data-products");
      if (e)
        try {
          const d = e.replace(/&quot;/g, '"').replace(/&#39;/g, "'"), u = JSON.parse(d);
          this.products = u.reduce((n, i) => (i != null && i.id && (n[i.id] = i), n), {});
        } catch (d) {
          console.error("Error parsing products data:", d), this.products = {};
        }
      const t = a.getAttribute("data-variants");
      if (t)
        try {
          const d = t.replace(/&quot;/g, '"').replace(/&#39;/g, "'"), u = JSON.parse(d);
          this.variants = u.reduce((n, i) => (i != null && i.id && (n[i.id] = i), n), {});
        } catch (d) {
          console.error("Error parsing variants data:", d), this.variants = {};
        }
    }
    const r = window.fetch;
    window.fetch = async function(...e) {
      var u;
      const [t, d] = e;
      if (typeof t == "string" && t.includes("/products/") && t.includes("undefined"))
        return console.error("Invalid product URL:", t), Promise.reject(new Error("Invalid product URL"));
      try {
        const n = await r.apply(this, e);
        if ((u = n.headers.get("content-type")) != null && u.includes("application/json")) {
          const i = await n.text();
          try {
            const s = JSON.parse(i);
            return new Response(JSON.stringify(s), {
              status: n.status,
              statusText: n.statusText,
              headers: n.headers
            });
          } catch {
            return console.error("Invalid JSON response:", i), Promise.reject(new Error("Invalid JSON response"));
          }
        }
        return n;
      } catch (n) {
        return console.error("Fetch error:", n), Promise.reject(n);
      }
    };
  }
  /**
   * Gets the singleton instance of CartApi.
   * Creates a new instance if one doesn't exist.
   */
  static getInstance() {
    return y.instance || (y.instance = new y()), y.instance;
  }
  /**
   * Sets the sections to be updated when cart changes occur.
   * Should be called only once during initialization.
   *
   * @param sections Array of sections to update
   */
  setSections(a) {
    this.sections = a;
  }
  /**
   * Gets the currently configured sections.
   */
  getSections() {
    return this.sections;
  }
  /**
   * Updates sections in the DOM with new HTML from Shopify response
   */
  updateSections(a) {
    a && Object.entries(a).forEach(([r, e]) => {
      const t = document.getElementById(r);
      if (!t) {
        console.log(`Section ${r} not found in DOM`);
        return;
      }
      if (t.tagName.toLowerCase().includes("-")) {
        const d = document.createElement("div");
        d.innerHTML = e;
        const u = d.querySelector(t.tagName.toLowerCase());
        if (u && t.parentNode) {
          if (t.tagName.toLowerCase() === "lit-mini-cart")
            this.updateMiniCart(t, u);
          else {
            const n = this.sections.find((i) => i.section === r);
            if (n != null && n.id) {
              const i = t.querySelector(`#${n.id}`), s = u.querySelector(`#${n.id}`);
              i != null && i.parentNode && s && i.parentNode.replaceChild(s, i);
            } else t.parentNode && t.parentNode.replaceChild(u, t);
          }
          u.dispatchEvent(
            new CustomEvent("shopify:section:load", {
              bubbles: !0,
              detail: { sectionId: r }
            })
          );
        }
      } else
        t.innerHTML = e, t.dispatchEvent(
          new CustomEvent("shopify:section:load", {
            bubbles: !0,
            detail: { sectionId: r }
          })
        );
    });
  }
  async updateMiniCart(a, r) {
    const e = a, t = r;
    !e || !t || (e.replaceWith(t), e.classList.contains("active") && (t.classList.add("active"), t.classList.add("animate")));
  }
  async validateBXGYRules(a) {
    await this.updateQueue.then(async () => {
      if (!this.isProcessingUpdate) {
        this.isProcessingUpdate = !0;
        try {
          if (!this.bxgyRules.length)
            return;
          const r = a, e = {};
          this.bxgyRules.forEach((s) => {
            r.items.some((o) => o.variant_id.toString() === s.variant_x_id) || r.items.filter((l) => {
              var _;
              const p = l.variant_id.toString() === s.variant_y_id, h = (_ = l.properties) == null ? void 0 : _._buyxgety;
              return p && h;
            }).forEach((l) => {
              e[l.key] = 0;
            });
          }), Object.keys(e).length > 0 && (await this.updateCart({ updates: e }), a = await this.getCart());
          const t = {};
          this.bxgyRules.forEach((s) => {
            s.variant_y_id && (t[s.variant_y_id] = 0);
          }), a.items.filter((s) => this.bxgyRules.some(
            (o) => s.variant_id.toString() === o.variant_x_id
          )).forEach((s) => {
            const c = this.bxgyRules.find((o) => o.variant_x_id === s.variant_id.toString());
            if (c && c.variant_y_id) {
              const o = Math.floor(s.quantity / c.quantity_x) * c.quantity_y;
              if (t[c.variant_y_id] += o, c.variant_y_inventory) {
                const l = t[c.variant_y_id];
                t[c.variant_y_id] = Math.min(t[c.variant_y_id], c.variant_y_inventory);
              }
            }
          });
          const u = {}, n = [];
          Object.entries(t).forEach(([s, c]) => {
            const o = Number(c);
            if (isNaN(o) || o <= 0)
              return;
            const l = this.bxgyRules.find(
              (h) => h.variant_y_id === s
            );
            if (!l)
              return;
            const p = a.items.find(
              (h) => {
                var _;
                return h.variant_id.toString() === s && ((_ = h.properties) == null ? void 0 : _._buyxgety);
              }
            );
            p ? p.quantity !== o && (u[p.key] = o) : n.push({
              id: s,
              quantity: o,
              properties: {
                _buyxgety: !0,
                _buyxgety_source: l.variant_x_id
              }
            });
          }), Object.keys(u).length > 0 && await this.updateCart({ updates: u }), n.length > 0 && await this.addToCart(n);
          const i = {};
          a.items.forEach((s) => {
            var l, p;
            const c = (l = s.properties) == null ? void 0 : l._gwp, o = (p = s.properties) == null ? void 0 : p._buyxgety;
            (c || o) && (!s.line_level_discount_allocations || s.line_level_discount_allocations.length === 0) && (i[s.key] = 0);
          }), Object.keys(i).length > 0 && await this.updateCart({ updates: i });
        } catch (r) {
          throw console.error("Error validating BXGY rules:", r), r;
        } finally {
          this.isProcessingUpdate = !1;
        }
      }
    });
  }
  /**
   * Updates item quantities in the cart.
   * Automatically triggers section updates.
   *
   * @param payload Object containing updates and section configuration
   * @throws Error if update fails
   */
  async updateCart(a) {
    var n;
    const r = window.__CART__;
    if (r && r.items && a.updates && Object.entries(a.updates).length === 1 && // Manual removals only remove one item at a time
    ((n = document.activeElement) == null ? void 0 : n.closest("cart-remove-button"))) {
      const s = JSON.parse(sessionStorage.getItem("gwp_removed") || "[]");
      Object.entries(a.updates).forEach(([c, o]) => {
        var h;
        const l = Number(o);
        if (isNaN(l)) {
          console.warn(`Invalid quantity value for key ${c}: ${o}`);
          return;
        }
        const p = c.split(":")[0];
        if (l === 0) {
          const _ = r.items.find((f) => f.id == p);
          if ((h = _ == null ? void 0 : _.properties) != null && h._gwp) {
            const f = _.properties._gwp_discount_id;
            f && !s.includes(f) && (s.push(f), sessionStorage.setItem("gwp_removed", JSON.stringify(s)));
          }
        }
      });
    }
    const e = {
      ...a,
      updates: Object.entries(a.updates).reduce((i, [s, c]) => {
        const o = Number(c);
        return isNaN(o) || (i[s] = o), i;
      }, {})
    }, t = await fetch(`${g()}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...e,
        sections: this.sections.map((i) => i.section),
        sections_url: window.location.pathname
      })
    });
    if (!t.ok) {
      const i = await t.json();
      throw new Error(`Cannot update cart: ${i == null ? void 0 : i.message} - ${i == null ? void 0 : i.description}`);
    }
    const d = await t.clone().json();
    return window.__CART__ = await this.getCart(), d.sections && this.updateSections(d.sections), Object.keys(e.updates).some((i) => {
      var c, o;
      const s = (c = r == null ? void 0 : r.items) == null ? void 0 : c.find((l) => l.key === i);
      return ((o = s == null ? void 0 : s.properties) == null ? void 0 : o._gwp) === "true";
    }) || await this.validateBXGYRules(window.__CART__), t;
  }
  /**
   * Adds items to the cart.
   * Automatically triggers section updates.
   *
   * @param items Array of items to add
   * @throws Error if add operation fails
   */
  async addToCart(a, r = !0) {
    const e = await fetch(`${g()}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: a,
        sections: this.sections.map((u) => u.section),
        sections_url: window.location.pathname
      })
    });
    if (!e.ok)
      throw new Error(`Failed to add items to cart: ${e.statusText}`);
    const t = await e.json();
    return t.sections && this.updateSections(t.sections), !a.some((u) => {
      var n;
      return ((n = u.properties) == null ? void 0 : n._gwp) === "true";
    }) && r && await this.validateBXGYRules(t), e;
  }
  async getCart() {
    const a = await fetch(`${g()}cart.js`);
    if (!a.ok)
      throw new Error("Cannot get cart");
    return await a.json();
  }
  /**
   * Removes a bundle from the cart by setting quantities of all bundle items to 0
   * @param bundleId The ID of the bundle to remove
   */
  async removeBundle(a) {
    const e = (await this.getCart()).items.filter((t) => {
      var d;
      return ((d = t == null ? void 0 : t.properties) == null ? void 0 : d._bundle_id_internal) === a;
    }).map((t) => t.key).reduce((t, d) => ({ ...t, [d]: 0 }), {});
    Object.keys(e).length > 0 && await this.updateCart({
      updates: e
    });
  }
}
window.CartApi = {
  getInstance: () => y.getInstance()
};
export {
  y as C
};
